"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationLogEntryType = exports.StatusXX = exports.Status = void 0;
/** HTTP statuses */
var Status;
(function (Status) {
    Status[Status["OK"] = 200] = "OK";
    Status[Status["CREATED"] = 201] = "CREATED";
    Status[Status["ACCEPTED"] = 202] = "ACCEPTED";
    Status[Status["NO_CONTENT"] = 204] = "NO_CONTENT";
    Status[Status["PARTIAL_CONTENT"] = 206] = "PARTIAL_CONTENT";
    Status[Status["MULTI_STATUS"] = 207] = "MULTI_STATUS";
    Status[Status["NOT_MODIFIED"] = 304] = "NOT_MODIFIED";
    Status[Status["BAD_REQUEST"] = 400] = "BAD_REQUEST";
    Status[Status["NOT_AUTHORIZED"] = 401] = "NOT_AUTHORIZED";
    Status[Status["PAYMENT_REQUIRED"] = 402] = "PAYMENT_REQUIRED";
    Status[Status["FORBIDDEN"] = 403] = "FORBIDDEN";
    Status[Status["NOT_FOUND"] = 404] = "NOT_FOUND";
    Status[Status["NOT_ALLOWED"] = 405] = "NOT_ALLOWED";
    Status[Status["NOT_ACCEPTABLE"] = 406] = "NOT_ACCEPTABLE";
    Status[Status["PROXY_AUTHENTICATION_REQUIRED"] = 407] = "PROXY_AUTHENTICATION_REQUIRED";
    Status[Status["REQUEST_TIMEOUT"] = 408] = "REQUEST_TIMEOUT";
    Status[Status["CONFLICT"] = 409] = "CONFLICT";
    Status[Status["GONE"] = 410] = "GONE";
    Status[Status["LENGTH_REQUIRED"] = 411] = "LENGTH_REQUIRED";
    Status[Status["PRECONDITION_FAILED"] = 412] = "PRECONDITION_FAILED";
    Status[Status["REQUEST_ENTITY_TOO_LARGE"] = 413] = "REQUEST_ENTITY_TOO_LARGE";
    Status[Status["UNSUPPORTED_MEDIA_TYPE"] = 415] = "UNSUPPORTED_MEDIA_TYPE";
    Status[Status["REQUEST_RANGE_NOT_SATISFIABLE"] = 416] = "REQUEST_RANGE_NOT_SATISFIABLE";
    Status[Status["EXPECTATION_FAILED"] = 417] = "EXPECTATION_FAILED";
    Status[Status["UNPROCESSABLE_ENTITY"] = 422] = "UNPROCESSABLE_ENTITY";
    Status[Status["THROTTLED"] = 429] = "THROTTLED";
    Status[Status["ENCRYPTION_ERROR"] = 463] = "ENCRYPTION_ERROR";
    Status[Status["REQUEST_TERMINATED"] = 487] = "REQUEST_TERMINATED";
    Status[Status["SERVER_ERROR"] = 500] = "SERVER_ERROR";
    Status[Status["NOT_IMPLEMENTED"] = 501] = "NOT_IMPLEMENTED";
    Status[Status["BAD_GATEWAY"] = 502] = "BAD_GATEWAY";
    Status[Status["SERVICE_UNAVAILABLE"] = 503] = "SERVICE_UNAVAILABLE";
    Status[Status["GATEWAY_TIMEOUT"] = 504] = "GATEWAY_TIMEOUT";
    Status[Status["INSUFFICIENT_STORAGE"] = 507] = "INSUFFICIENT_STORAGE";
    Status[Status["BANDWIDTH_LIMIT_EXCEEDED"] = 509] = "BANDWIDTH_LIMIT_EXCEEDED";
    Status[Status["SERVER_TIMEOUT"] = 599] = "SERVER_TIMEOUT";
})(Status || (exports.Status = Status = {}));
/**
 * Class of HTTP status code, should have only string values
 */
var StatusXX;
(function (StatusXX) {
    StatusXX["HTTP_2XX"] = "2xx";
    StatusXX["HTTP_4XX"] = "4xx";
    StatusXX["HTTP_5XX"] = "5xx";
})(StatusXX || (exports.StatusXX = StatusXX = {}));
var OperationLogEntryType;
(function (OperationLogEntryType) {
    OperationLogEntryType["Initial"] = "Initial";
    OperationLogEntryType["Auth"] = "Auth";
    OperationLogEntryType["AuthDecorate"] = "AuthDecorate";
    OperationLogEntryType["AuthResolve"] = "AuthResolve";
    OperationLogEntryType["BaseUrlResolve"] = "BaseUrlResolve";
    OperationLogEntryType["Retry"] = "Retry";
    OperationLogEntryType["RetryDelay"] = "RetryDelay";
    OperationLogEntryType["Redirect"] = "Redirect";
    OperationLogEntryType["Throttle"] = "Throttle";
})(OperationLogEntryType || (exports.OperationLogEntryType = OperationLogEntryType = {}));
